import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  samlProvider: () => getUrlForEnv(services.SSO_SERVICE, "/v1/provider"),
  workOSGetAuth: () => getUrlForEnv(services.SSO_APP_SERVICE, "/v1/auth-url"),
  workOSLogin: (connectionId: string, code: string) => getUrlForEnv(services.SSO_APP_SERVICE, `/connection/${connectionId}/login/${code}`)
}

export default endpoints
